import { lazyRouteComponent } from "@tanstack/react-router";
import { UserPlus } from "lucide-react";

import type { PageDef } from "@/app/registry";

/**
 * Sign-up is used before there is a session, so it must not sit under the
 * signed-in shell. The registry only mounts signed-in pages, so this area
 * exports nothing in `pages` and offers `publicPages` for the router to mount
 * next to /login (integration step; see the platform-accounts notes).
 */
export const pages: PageDef[] = [];

export const publicPages: PageDef[] = [
  {
    path: "/signup",
    title: "Create account",
    component: lazyRouteComponent(() => import("./SignupPage"), "SignupPage"),
    nav: { label: "Sign up", icon: UserPlus, group: "System", order: 99 },
    // ?role=ra opens the research-analyst form; ?plan= picks an RA plan (the RA pricing page)
    validateSearch: (s) => ({
      ...(s.role === "ra" || s.role === "investor" ? { role: s.role } : {}),
      ...(typeof s.plan === "string" && /^[a-z][a-z0-9_]{1,39}$/.test(s.plan) ? { plan: s.plan } : {}),
    }),
  },
];
